export function isShortcutDialogKey(
  e: Pick<KeyboardEvent, "code" | "ctrlKey" | "key" | "metaKey" | "repeat" | "shiftKey">,
): boolean {
  if (e.repeat) return false;
  if (!(e.metaKey || e.ctrlKey)) return false;
  return e.key === "/" || (e.code === "Slash" && !e.shiftKey);
}
